export const resolveEndpoint = (
	endpoint,
	{
		bankId = null,
		scopeId = null,
		accountId = null,
		mandateId = null,
		batchId = null,
		paymentId = null,
		templateId = null,
		mandateType = null,
		beneficiaryId = null,
		calendarType = null,
		customerId = null,
		page = '',
		size = '',
		search = '',
		benType = '',
		paymentType = '',
		accountNumber = '',
		sortCode = '',
		name = '',
		effectiveWarningId = null,
		customerType = null,
		journey = '',
		isMultipleApproval = '',
		mandateRecordType = '',
		mandateStartIndex = null,
		mandateMaxRecords = null,
	}
) => {
	let newEndpoint = endpoint;
	if (bankId) {
		newEndpoint = newEndpoint.replace(':bankId', bankId);
	}
	if (scopeId) {
		newEndpoint = newEndpoint.replace(':scopeId', scopeId);
	}
	if (accountId) {
		newEndpoint = newEndpoint.replace(':accountId', accountId);
	}
	if (mandateId) {
		newEndpoint = newEndpoint.replace(':mandateId', mandateId);
	}
	if (batchId) {
		newEndpoint = newEndpoint.replace(':batchId', batchId);
	}
	if (paymentId) {
		newEndpoint = newEndpoint.replace(':paymentId', paymentId);
	}
	if (templateId) {
		newEndpoint = newEndpoint.replace(':templateId', templateId);
	}
	if (mandateType) {
		newEndpoint = newEndpoint.replace(':mandateType', mandateType);
	}
	if (beneficiaryId) {
		newEndpoint = newEndpoint.replace(':beneficiaryId', beneficiaryId);
	}
	if (calendarType) {
		newEndpoint = newEndpoint.replace(':calendarType', calendarType);
	}
	if (customerId) {
		newEndpoint = newEndpoint.replace(':customerId', customerId);
	}
	newEndpoint = newEndpoint.replace(':page', page);
	newEndpoint = newEndpoint.replace(':size', size);
	newEndpoint = newEndpoint.replace(':search', search);
	newEndpoint = newEndpoint.replace(':benType', benType);
	newEndpoint = newEndpoint.replace(':paymentType', paymentType);
	newEndpoint = newEndpoint.replace(':accountNumber', accountNumber);
	newEndpoint = newEndpoint.replace(':sortCode', sortCode);
	newEndpoint = newEndpoint.replace(':name', name);
	newEndpoint = newEndpoint.replace(':effectiveWarningId', effectiveWarningId);
	newEndpoint = newEndpoint.replace(':customerType', customerType);
	newEndpoint = newEndpoint.replace(':journey', journey);
	newEndpoint = newEndpoint.replace(':isMultipleApproval', isMultipleApproval);
	newEndpoint = newEndpoint.replace(':verificationId', effectiveWarningId);
	newEndpoint = newEndpoint.replace(':mandateRecordType', mandateRecordType);
	newEndpoint = newEndpoint.replace(':mandateStartIndex', mandateStartIndex);
	newEndpoint = newEndpoint.replace(':mandateMaxRecords', mandateMaxRecords);

	return newEndpoint;
};
